module.exports = __webpack_public_path__ + "img/Exhibition_Logo.5cd530b9.png";